import React from 'react';
import CheckoutSummaryHeader from '../../Cart/CheckoutSummaryHeader';
import NavHeader from '../../Cart/NavHeader';
import styles from '../../Cart/Root/styles.module.scss';
import SubmissionConfirmationPanel from '../SubmissionConfirmationPanel';

export const SubmissionSuccess = props => {
  return (
    <div className={styles.cartDashboard}>
      <NavHeader />
      <CheckoutSummaryHeader />
      <SubmissionConfirmationPanel history={props.history} />
    </div>
  );
};

export default SubmissionSuccess;
